export default __webpack_public_path__ + "static/media/BF40CE15-DDDD-4B07-B503-29DDE82B4149_1_105_c.876acc78.jpeg";